<template>
  <div>
    <pc-dialog title="活动规则" :visible.sync="dialogVisible" @close="close" @confirm="close">
      <template #content>
        <div class="rule">{{ rule }}</div>
      </template>
    </pc-dialog>
  </div>
</template>

<script>
import PcDialog from '../dialog/Index.vue'

export default {
  name: 'PcRuleDialog',
  components: {
    PcDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rule: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.rule {
  margin-bottom: 30px;
  min-height: 300px;
  font-size: 18px;
  white-space: pre-wrap;
}
</style>